module.exports = __webpack_public_path__ + "ath_game_web/img/Telegram_Logo.be98fe7e.png";